/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as PasswordInput } from "./PasswordInput";
export type { PasswordInputProps } from "./PasswordInputProps";
